export default "__VITE_ASSET__6484fca2__"